import { Row, Tooltip, Typography, red } from 'enable-ui';

import type { InputTitleProps } from './type';

import { COLOR_CONFIG } from 'constants/color';

export const InputTitle: React.FC<InputTitleProps> = ({
  title,
  required,
  style,
  icon,
  contentTooltip,
  styleRow,
  unsetMarginBottom,
  unsetWidth,
  extraClass = '',
}) => {
  return (
    <Row
      align="center"
      className={`${extraClass}`}
      style={{
        marginBottom: unsetMarginBottom ? 0 : 6,
        ...styleRow,
        width: unsetWidth ? 'unset' : styleRow?.width,
      }}
    >
      <Typography
        weight={600}
        variant="body-3"
        color={COLOR_CONFIG['neutral-text']}
        style={{
          marginRight: required ? 0 : 4,
          ...style,
        }}
      >
        {title}
      </Typography>
      {required && (
        <Typography
          style={{
            marginLeft: 2,
            marginRight: 4,
          }}
          weight={600}
          color={red['red-6']}
        >
          *
        </Typography>
      )}

      {icon && (
        <Tooltip content={contentTooltip} allowHTML interactive>
          <div style={{ height: 18 }}>{icon}</div>
        </Tooltip>
      )}
    </Row>
  );
};
